import { Link } from '@tanstack/react-router';
import { CircleArrowLeft } from 'lucide-react';

import { AttendanceClassListTable } from '~features/classes/ui/attendance-class-list-table';

export const AttendanceClassListPage = () => {
  return (
    <div className=''>
      <Link to='/dashboard' className='flex w-fit items-center gap-2'>
        <CircleArrowLeft className='size-6' />
        <h2 className='text-2xl font-semibold'>Classes Attendance</h2>
      </Link>
      <div className='mb-6 mt-8 border-t' />
      <AttendanceClassListTable />
    </div>
  );
};
